import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "map-elem-info-area compare-mode" }
const _hoisted_2 = {
  key: 0,
  class: "confirm-create"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = ["disabled"]

import MapElemInfoNew from 'src/components/Top/mapElemInfoComponents/MapElemInfoNew.vue';
import type { GeoItemMeta, GIComment, GIMovieGeoIndex } from 'src/models/geoItem';
import type { MapElemInfo } from 'src/models';
import type { CompareModeMapElemInfoState } from 'src/models/moviePlayer';


export default /*@__PURE__*/_defineComponent({
  __name: 'MapElemPinCreator',
  props: {
    mapElemInfo: {},
    mapElemIconPath: {},
    visibleGeoItemLayers: {},
    currentMgi: {},
    createFailed: {}
  },
  emits: ["startCreate", "create", "cancelEdit"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!__props.mapElemInfo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("img", {
            class: "map-elem-icon",
            src: __props.mapElemIconPath
          }, null, 8, _hoisted_3),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('startCreate'))),
            disabled: !__props.currentMgi
          }, " 現在位置に付箋を追加 ", 8, _hoisted_4)
        ]))
      : (_openBlock(), _createBlock(MapElemInfoNew, {
          key: 1,
          elem: __props.mapElemInfo,
          "visible-layers": __props.visibleGeoItemLayers,
          "force-show-cancel-button": true,
          "create-failed": __props.createFailed,
          onCreate: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('create', $event))),
          onCancelEdit: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('cancelEdit')))
        }, null, 8, ["elem", "visible-layers", "create-failed"]))
  ]))
}
}

})